document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', (event) => {
    const productCard = event.target.closest('.js-product-card-v2')
    if (!productCard) return

    const data = {
      productId: productCard.getAttribute("id"),
      productName: productCard.getAttribute("title"),
      productPrice: Number(productCard.getAttribute("data-analytics-price")),
      productSku: productCard.getAttribute("sku"),
    };

    Shopify.analytics.publish("custom_product_clicked", { data });
  })
});

document.addEventListener("nova:analyticsProductRemoved", async (event) => {
  const response = await fetch("/cart.js");
  const cart = await response.json();
  Shopify.analytics.publish('custom_product_removed_from_cart', { data: {cart, removedProduct: event.detail} });
});
